import Cookies from 'js-cookie'
const tokenKey = 'accessToken'
const userKey = 'username'

export function getToken() {
    let accessToken = Cookies.get(tokenKey);
    return accessToken;
}

export function setToken(item) {
    let expiresTime = new Date(new Date().getTime() + (item.expires_in * 1000))
    Cookies.set(tokenKey, item.access_token, {expires: expiresTime})
}

export function removeToken() {
    Cookies.remove(tokenKey)
}

export function setUsername(username) {
    Cookies.set(userKey, username)
}

export function getUsername() {
    let username = Cookies.get(userKey)
    return username;
}


